import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

export interface DropdownOption {
  label: string;
  value: string;
}

export interface GetOptionsResponse {
  options: DropdownOption[];
}

export interface UploadExcelResponse {
  message: string;
  log_id: string;
}

export interface PushToLiveLog {
  _id: string;
  file_name: string;
  input_file_path: string;
  output_file_path: string;
  status: string;
  start_date_script: string;
  end_date_script: string;
  error_message: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class PushToLiveService {

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) { }

  getOptions(): Observable<GetOptionsResponse> {
    return this.http
      .get<GetOptionsResponse>(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.PUSH_TO_LIVE.GET_OPTIONS}`
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  uploadExcel(file: File, processType: string): Observable<UploadExcelResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('process_type', processType);

    return this.http
      .post<UploadExcelResponse>(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.PUSH_TO_LIVE.UPLOAD_EXCEL}`,
        formData
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRecords(): Observable<PushToLiveLog[]> {
    return this.http
      .get<PushToLiveLog[]>(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.PUSH_TO_LIVE.GET_RECORDS}`
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
